/** Modal Components
 *
 * `ControlledModal` is a modal. It implements it own mecanism of opening and
 * closing by clicking on the trigger element.
 *
 * `Modal` is a  modal view. It expects from the calling component to tell if
 * the modal should be open or closed by the open prop.
 */
export { default as ControlledModal, Context } from "./controller";
export { default as Modal } from "./view";
